"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRemoveSuggestion = exports.trackSelectSuggestion = exports.trackTravelDestinations = exports.TravelDestinationsEventType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var TravelDestinationsEventType;
(function (TravelDestinationsEventType) {
    TravelDestinationsEventType["TRAVEL_DESTINATIONS_OPEN"] = "\uD83D\uDE80 search.text.open";
    TravelDestinationsEventType["TRAVEL_DESTINATIONS_CANCEL"] = "\uD83D\uDE80 search.text.cancel";
    TravelDestinationsEventType["TRAVEL_DESTINATIONS_APPLY"] = "\uD83D\uDE80 search.text.apply";
    TravelDestinationsEventType["TRAVEL_DESTINATIONS_RESULTS"] = "\uD83D\uDE80 search.text.results";
    TravelDestinationsEventType["TRAVEL_DESTINATIONS_ADD"] = "\uD83D\uDE80 search.text.add";
    TravelDestinationsEventType["TRAVEL_DESTINATIONS_REMOVE"] = "\uD83D\uDE80 search.text.remove";
})(TravelDestinationsEventType || (exports.TravelDestinationsEventType = TravelDestinationsEventType = {}));
const trackTravelDestinations = (action) => {
    switch (action.type) {
        case TravelDestinationsEventType.TRAVEL_DESTINATIONS_OPEN:
        case TravelDestinationsEventType.TRAVEL_DESTINATIONS_CANCEL:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: {},
                _clear: true,
            });
            break;
        case TravelDestinationsEventType.TRAVEL_DESTINATIONS_APPLY:
        case TravelDestinationsEventType.TRAVEL_DESTINATIONS_REMOVE:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: { suggestions: action.payload.suggestions },
                _clear: true,
            });
            break;
        case TravelDestinationsEventType.TRAVEL_DESTINATIONS_RESULTS:
        case TravelDestinationsEventType.TRAVEL_DESTINATIONS_ADD:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: Object.assign({ suggestions: action.payload.suggestions, text: action.payload.text }, (action.type ===
                    TravelDestinationsEventType.TRAVEL_DESTINATIONS_RESULTS
                    ? { hasMore: action.payload.hasMore, first: action.payload.first }
                    : {
                        position: action.payload.position,
                        auto: action.payload.auto || false,
                    })),
                _clear: true,
            });
            break;
        default:
            break;
    }
};
exports.trackTravelDestinations = trackTravelDestinations;
const trackSelectSuggestion = (suggestion, text) => {
    (0, exports.trackTravelDestinations)({
        type: TravelDestinationsEventType.TRAVEL_DESTINATIONS_ADD,
        payload: {
            suggestions: [suggestion],
            text,
            position: suggestion.label.toLowerCase().indexOf(text.toLowerCase()),
        },
    });
};
exports.trackSelectSuggestion = trackSelectSuggestion;
const trackRemoveSuggestion = (suggestion, text) => {
    (0, exports.trackTravelDestinations)({
        type: TravelDestinationsEventType.TRAVEL_DESTINATIONS_REMOVE,
        payload: {
            suggestions: [suggestion],
            text,
        },
    });
};
exports.trackRemoveSuggestion = trackRemoveSuggestion;
//# sourceMappingURL=trackTravelDestinations.js.map